import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { MenuProvider } from "../shared/context/MenuContext";
import NavOverlay from "../shared/components/layout/NavOverlay/NavOverlay";
import Header from "../shared/components/layout/Header/Header";
import MouseFollower from "../shared/components/MouseFollower/MouseFollower";
import { useHeaderTheme } from "../shared/hooks/useHeaderTheme";

import cursorDefault from "../assets/images/cursor/cursor_default.png";
import cursor01 from "../assets/images/cursor/cursor_01.png";
import cursor02 from "../assets/images/cursor/cursor_02.png";
import cursor03 from "../assets/images/cursor/cursor_03.png";
import cursor04 from "../assets/images/cursor/cursor_04.png";
import cursor05 from "../assets/images/cursor/cursor_05.png";
import cursor06 from "../assets/images/cursor/cursor_06.png";

const CURSOR_IMAGES = [cursorDefault, cursor01, cursor02, cursor03, cursor04, cursor05, cursor06];

function AppContent() {
  const theme = useHeaderTheme();
  const { pathname } = useLocation();
  const [showMouseFollower, setShowMouseFollower] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }, [pathname]);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 769px)");
    const update = () => setShowMouseFollower(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return (
    <>
      <Header theme={theme} />
      <div className="app-wrapper">
        <Outlet />
        <NavOverlay />
      </div>
      {showMouseFollower && (
        <MouseFollower images={CURSOR_IMAGES} interval={4000} />
      )}
    </>
  );
}

function App() {
  return (
    <MenuProvider>
      <AppContent />
    </MenuProvider>
  );
}

export default App;
